import "../styles/carousel.scss";
import React, { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import '../styles/projects.scss';
import { Fadeout } from "react-reveal";
import { useRef } from "react";
import { projects } from "../constants/constants";
import { useDispatch, useSelector } from "react-redux";

const Carousel = (props) => {


        //Defining image folder name inside public folder
        const imageFolder = "projects"/*props.imageFolder;*/

    /********************Defining Hooks****************************/

    const storeCurrentProject = state => state.carouselCurrentProject;
    const currentProject = useSelector(storeCurrentProject)

    const storeCurrentImage = state => state.carouselCurrentImage;
    const currentImage = useSelector(storeCurrentImage)

    //Defining the number of images to cycle
    /*const [numberOfImages, setNumberOfImages] = useState(props.nbOfImages -1);/*props.numberOfImages;*/

    const storeNumberOfImages = state => state.carouselNbOfImages;
    const numberOfImages = useSelector (storeNumberOfImages);

    const [directionOfNav, setDirectionOfNav] = useState(null);

    const [carouselHeight, setCarouselHeight] = useState(null)

    const previousRef = useRef(null);
    const currentRef= useRef(null);
    const carouselRef = useRef();

    
    const dispatch = useDispatch();

    /*******************Defining local functions *****************/

    /*Moves to the next picture*/
    const nextPicture = () => {
        setDirectionOfNav("right")
        if (currentImage === numberOfImages ) {
            dispatch({type : 'carousel/set/currentImage', payload : 0 })
          }
          else {
            dispatch({type : 'carousel/set/currentImage', payload : currentImage + 1 })
          }
    }
    /*Moves to the previous picture*/
    const previousPicture = () => {
        setDirectionOfNav("left")
        if (currentImage === 0 ) {
            dispatch({type : 'carousel/set/currentImage', payload : numberOfImages })
        }
        else {
            dispatch({type : 'carousel/set/currentImage', payload : currentImage - 1 })
        } 
      }

    /*Get the index of the previous image in a given context to display it*/
    const getPreviousPosition = (currentImage, directionOfNav, numberOfImages) => {
        if (currentImage === numberOfImages && directionOfNav === "left") {
            return 0
        } else if (currentImage !== numberOfImages && directionOfNav === "left") {
            return currentImage + 1
        } else if (currentImage === 0 && directionOfNav === "right") {
            return numberOfImages
        } else if (currentImage !== 0 && directionOfNav === "right") {
            return currentImage - 1
    }
}
    
    

    /*What Happens after the component renders*/
    useEffect(() => {
        console.log(currentRef.current.clientHeight);

        /*setCarouselHeight(currentRef.current.clientHeight);*/
        console.log("number of images "+numberOfImages)

        dispatch({type : 'carousel/set/currentNbOfImages', payload : projects[currentProject].nbOfImages -1 })

        if (currentImage > numberOfImages) {
            dispatch({type : 'carousel/set/currentImage', payload : 0 })
        }

        if (directionOfNav === "right" ) {        
            previousRef.current.className = 'background-carousel__image background-carousel__image--exit-right'
            currentRef.current.className = 'background-carousel__image background-carousel__image--enter-left'
        } else if (directionOfNav === "left" ){
            previousRef.current.className = 'background-carousel__image background-carousel__image--exit-left'
            currentRef.current.className = 'background-carousel__image background-carousel__image--enter-right'
        }

        


    }, [currentImage, directionOfNav, numberOfImages, currentProject, dispatch, setCarouselHeight]);

    
    return (
        <div style={{height: carouselHeight}} className = "background-carousel" key={nanoid() } ref={carouselRef}>

            <button className = 'background-carousel__button' onClick = {(e)=> {
                previousPicture()
            }}><i class="fas fa-chevron-left"></i></button>

            <button className = 'background-carousel__button'  onClick = {(e)=> {
                nextPicture()
            }}><i class="fas fa-chevron-right"></i></button>

            <img src={'images/'+imageFolder+'/'+ projects[currentProject].folder +'/'+ getPreviousPosition(currentImage, directionOfNav, numberOfImages)+'.png'}  alt={imageFolder} className='background-carousel__image--hidden' ref={previousRef} />
            <img src={'images/'+imageFolder+'/'+ projects[currentProject].folder +'/'+ currentImage+'.png'}  alt={imageFolder} className='background-carousel__image' ref={currentRef}/>
        </div>
        
        

    )
    
}

export default Carousel









/*import '../styles/projects.scss'
import { useState } from 'react'
import { projects } from '../constants/constants'
import { useEffect } from 'react'

const Projects = () => {

        

        const [currentImage, setCurrentImage] = useState("/images/"+projects[currentProject].image+".png")

    useEffect( () => {
         setCurrentImage("/images/"+projects[currentProject].image+".png")
    }, [currentProject])



    const navigateProjects = (increment) => {
        if (currentProject + increment === projects.length) {
            setCurrentProject(0)
        }
        else if (currentProject + increment === - 1) {
            setCurrentProject(projects.length - 1)
        }
        else {
            setCurrentProject(currentProject + increment)
        }
    }

    return <div className = 'projects'>
        
        <button className = 'projects__nav' onClick = {(e)=> {
            console.log("going left")
            navigateProjects(-1)
        }}>Go left</button>

            <img src = {currentImage} className = 'projects__project-container' ></img>
        
        <button className = 'projects__nav'  onClick = {(e)=> {
            navigateProjects(1)
        }}>Go right</button>
        
    </div>
}
export default Projects*/